"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = exports.STATUS_COLORS = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
exports.STATUS_COLORS = [
    { color: '#333', backgroundColor: '#F48F93' },
    { color: '#333', backgroundColor: '#FEC400' },
    { color: '#333', backgroundColor: '#ABE5C3' },
    { color: '#333', backgroundColor: '#ACE0F6' },
    { color: '#333', backgroundColor: '#DFE0EB' } // gray
];
function isSameStatusColor(colorA, colorB) {
    return (colorA.color === colorB.color &&
        colorA.backgroundColor === colorB.backgroundColor);
}
const StyledColorBlock = styled_components_1.default.div `
  position: relative;
  width: auto;
  height: auto;
  margin-left: 1px;
  margin-right: 1px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 2px solid
    ${props => (props.selected ? props.color : 'rgba(255, 255, 255, 0)')};
  transition: border 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    cursor: pointer;
    border: 2px solid ${props => props.color};
  }
  .content {
    width: 38px;
    height: 30px;
    font-size: 1.5em;
    font-weight: 500;
    border-radius: 6px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      font-size: 1.35em;
    }
  }
`;
const ColorPicker = props => {
    const { onChange } = props;
    const color = props.color && typeof props.color === 'object' ? props.color : undefined;
    return (react_1.default.createElement(core_1.Grid, { container: true }, exports.STATUS_COLORS.map((colorStyle, index) => {
        const { backgroundColor } = colorStyle;
        const selected = !!color && isSameStatusColor(color, colorStyle);
        return (react_1.default.createElement(StyledColorBlock, { selected: selected, color: backgroundColor, key: `${backgroundColor}-${index}`, onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(selected ? undefined : colorStyle) },
            react_1.default.createElement("div", { className: 'content', style: colorStyle }, selected && react_1.default.createElement(icons_1.Check, { color: 'inherit', className: 'icon' }))));
    })));
};
exports.ColorPicker = ColorPicker;
exports.default = exports.ColorPicker;
//# sourceMappingURL=ColorPicker.js.map